
import React from 'react';
import AppLayout from '@/components/AppLayout';
import { AppProvider } from '@/contexts/AppContext';
import BrandingBootstrap from '@/components/BrandingBootstrap';

const Index: React.FC = () => {
  return (
    <AppProvider>
      <BrandingBootstrap />
      <AppLayout />
    </AppProvider>
  );
};

export default Index;
